import React, { useEffect } from "react"
import { useApp } from "../../hooks/useApp"

export const withModalsDrawer = Component => ({ name = "ModalsDrawer", active, ...props }) => {
  Component.displayName = name
  const {
    config: {
      settings: { routes },
    },
    globalStateReducer,
  } = useApp()
  const [{ activeMenu, activeCart }] = globalStateReducer

  useEffect(() => {
    if (active && props?.type !== "filter") {
      document.body.className = "overflow-hidden"
    } else {
      document.body.className = ""
    }
  }, [active])
  return <Component active={active} {...props} activeMenu={activeMenu} activeCart={activeCart} />
}
